import {MEETING_STATUS_CANCELLED} from '../constants';

/**
 * Checks if a meeting is cancelled.
 *
 * @param {Object} meeting - The meeting object to check.
 * @return {boolean} Returns true if the meeting is cancelled, false otherwise.
 */
export function isMeetingCancelled(meeting) {
    if (!meeting) return false;

    return !!(
        meeting.cancelled ||
        meeting.state == MEETING_STATUS_CANCELLED ||
        (meeting.invited?.length && meeting.invited?.filter(m => m.state == MEETING_STATUS_CANCELLED).length == meeting.invited?.length)
    );
}
